import React, { useState } from "react";
import { Button, Stack, Typography, Chip } from "@mui/material";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import WageDocumentsModal from "./Wagedocumentsmodal";
import { downloadFileWithFileName } from "../../../utils/formHelper";
import "./Wagedocumentsupload.scss";

const WageDocumentsUpload = ({ disabled = false, files = [], onAddFile, onLabelChange, onDeleteFile }) => {
  const [modalOpen, setModalOpen] = useState(false);


  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);
  const handleDone = () => setModalOpen(false);

  const handleAddFile = file => onAddFile?.(file);
  const handleLabelChange = (fileId, label) => onLabelChange?.(fileId, label);
  const handleDeleteFile = fileId => onDeleteFile?.(fileId);

  const handleViewFile = file => {
    if (file?.file) {
      const objectUrl = URL.createObjectURL(file.file);
      window.open(objectUrl, "_blank", "noopener,noreferrer");
      setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
      return;
    }

    if (file?.url) {
      window.open(file.url, "_blank", "noopener,noreferrer");
    }
  };

  const handleDownloadFile = file => {
    if (file?.file) {
      const objectUrl = URL.createObjectURL(file.file);
      downloadFileWithFileName(objectUrl, file.name);
      setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
      return;
    }

    if (file?.url) {
      downloadFileWithFileName(file.url, file.name);
    }
  };
  

  return (
    <Stack spacing={1} className="wage-documents-upload_container">
      {files.length === 0 ? (
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            variant="outlined"
            startIcon={<UploadFileOutlinedIcon />}
            onClick={handleOpen}
            disabled={disabled}
            className="wage-documents-upload_trigger-btn"
          >
            Upload File
          </Button>

          {!disabled && (
            <Typography variant="caption" color="text.secondary">
              PDF, TXT, DOC, PNG or JPEG &bull; 10 MB max
            </Typography>
          )}
        </Stack>
      ) : (
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Button
            variant="outlined"
            startIcon={<FolderOpenOutlinedIcon />}
            onClick={handleOpen}
            className="wage-documents-upload_trigger-btn"
          >
            Manage Files
          </Button>

          <Chip
            size="small"
            icon={<AttachFileIcon fontSize="small" />}
            label={`${files.length} attached`}
            className="wage-documents-upload_count-chip"
          />
        </Stack>
      )}

      <WageDocumentsModal
        open={modalOpen}
        onClose={handleClose}
        onDone={handleDone}
        files={files}
        disabled={disabled}
        onAddFile={handleAddFile}
        onLabelChange={handleLabelChange}
        onDeleteFile={handleDeleteFile}
        onViewFile={handleViewFile}
        onDownloadFile={handleDownloadFile}
      />
    </Stack>
  );
};

export default WageDocumentsUpload;